import type React from 'react';
import { Toast } from '@zillow/constellation';

const UnmaskedToast = (props: React.ComponentProps<typeof Toast>) => {
  return <Toast {...props} className="fs-unmask" />;
};

export default UnmaskedToast;
